export class SelectOption {
    constructor(public value: string,
                public label: string) {
    }
}
